import { render, staticRenderFns } from "./EmailReport.vue?vue&type=template&id=fabc04ee&scoped=true&"
import script from "./EmailReport.vue?vue&type=script&lang=js&"
export * from "./EmailReport.vue?vue&type=script&lang=js&"
import style0 from "./EmailReport.vue?vue&type=style&index=0&id=fabc04ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabc04ee",
  null
  
)

export default component.exports